export default "__VITE_PUBLIC_ASSET__e7f664b0__"